import React, { useState, useEffect } from "react";
import ApiService from "../services/ApiService";
import GoogleMapWithMarkers from "../components/GoogleMapWithMarkers";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import mapIcon from "../assets/images/map-icon.png";


const PickupTab = () => {

    const [branches, setBranches] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [isLoader, setIsLoader] = useState(false);
    const [userLocation, setUserLocation] = useState(null);
    const [mapCenter, setMapCenter] = useState(null);
    const navigate = useNavigate();
    
    // Convert 24-hour format to 12-hour format
    const formatTime12Hour = (time24) => {
        if (!time24) return '';
        const [hours, minutes] = time24.split(':');
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minutes} ${ampm}`;
    };

    // Get user's current location
    const getUserLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setUserLocation({ lat: latitude, lng: longitude });
                    setMapCenter({ lat: latitude, lng: longitude });
                    console.log('User location:', { lat: latitude, lng: longitude });
                },
                (error) => {
                    console.error('Error getting location:', error);
                    toast.error('Unable to get your location. Please enable location services.');
                }
            );
        } else {
            toast.error('Geolocation is not supported by this browser.');
        }
    };

    useEffect(() => {
        getUserLocation();
    }, []);

    useEffect(() => {
        if (userLocation) {
            getBranches();
        }
    }, [userLocation]);

    const getBranches = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "/getBranches",
                data: {
                    lat: userLocation?.lat,
                    lng: userLocation?.lng
                }
            });
            const data = response.data;

            console.log(data);
            if (data.status) {
                setBranches(data.data.branches); 
                console.log(data);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            console.error("Dashboard loading error:", error);
            toast.error("Failed to load dashboard");
        } finally {
            setIsLoader(false);
        }
    };

    // Handle branch selection
    const handleBranchClick = (branch) => {
        if (!branch.today_timing?.is_open) {
            toast.error('Branch is closed, try another');
            return;
        }
        
        setSelectedBranch(branch);
        // Center map on selected branch
        setMapCenter({ lat: branch.lat, lng: branch.lng });
    };

    const setPickup = async () => {
        // localStorage.removeItem("address");
        if(!selectedBranch){
            toast.error("Select branch to continue");
            return 0;
        }
        localStorage.setItem("branch", JSON.stringify(selectedBranch));
        
        const searchParams = new URLSearchParams(window.location.search);
        const goto = searchParams.get('goto') || '';
        navigate('/'+goto+"?tab=pickup&change=false");
    };


    return (
        <div className='pickup-tab h-100'>
             <GoogleMapWithMarkers 
                markers={branches} 
                center={mapCenter}
                selectedBranch={selectedBranch}
             />

             <div className=" row px-3">
                {branches.map((branch, index) => (
                    <div className="col-md-6 col-12" key={branch._id}>
                        <div className={`branch-card cursor-pointer bg-white shadow ${selectedBranch?._id==branch._id ? 'active' : ''}`}
                            onClick={() => handleBranchClick(branch)}>
                            <div className="row">
                                <div className="col-2 ">
                                    <img src={mapIcon} alt="map" className="w-lg-50 w-100 " />
                                </div>
                                <div className="col-10">
                                    Wingstop: {branch.name}
                                    <span className={`float-end badge ${branch.today_timing.is_open ? 'badge-light-success' : 'badge-light-danger'}`}>{branch.today_timing.is_open?'Open':'Close'}</span>
                                    <div className="row my-2">
                                        <small className="col-6"> <i className="bi bi-geo-alt-fill text-base"></i> {branch.distance || 0} km</small>
                                        <small className="col-6"> <i className="bi bi-telephone-plus-fill text-base"></i> +{branch.phone}</small>
                                    </div>
                                    <div className="row my-2">
                                        <small className="col-6"> <i className="bi bi-clock-fill text-base "></i> {formatTime12Hour(branch.today_timing?.timing?.open_time)} - {formatTime12Hour(branch.today_timing?.timing?.close_time)} </small>
                                        <small className="col-6">
                                            <a  href={"https://www.google.com/maps?q="+branch.lat+","+branch.lng}  className="text-base"
                                                target="_blank" 
                                                rel="noopener noreferrer">
                                            Get Directions <i className="bi bi-box-arrow-up-right text-base "></i> </a></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                <div className="row px-3 mt-5"> <br />
                    <div className="col-md-6">
                        <button className="btn btn-base btn-lg my-3 continue-btn" onClick={()=>setPickup()}>Continue</button>
                    </div>
                </div>
             </div>
        </div>
    );
};



export default PickupTab;
